import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * "Every limit, defined" block. Short definitions for each metering
 * dimension used by the live catalog, pulled from the copy deck.
 */
import { sans } from '../fonts.js';
import { labelFromSlug } from './copy-deck.js';
export function LimitsBlock({ theme, copy, data }) {
    // Collect every dimension the live catalog uses, so a staff-added
    // dimension gets a definition. Keep display order deterministic.
    const canonical = ['page_loads_monthly', 'orders_monthly', 'assistant_requests_monthly', 'retention_days'];
    const extra = Array.from(new Set(data.plans.flatMap((p) => p.limits.map((l) => l.dimension)))).filter((d) => !canonical.includes(d));
    const dims = [...canonical, ...extra].filter((d) => copy.dimensions[d] !== undefined);
    return (_jsxs("details", { className: "pr-limits", style: { borderTop: `1px solid ${theme.border}`, paddingTop: 14 }, children: [_jsx("summary", { style: {
                    ...sans,
                    fontSize: 15,
                    fontWeight: 500,
                    color: theme.text,
                    cursor: 'pointer',
                    marginBottom: 4,
                }, children: "How limits are counted" }), _jsx("div", { className: "pr-def-grid", style: {
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                    gap: '16px 32px',
                    marginTop: 14,
                }, children: dims.map((d) => {
                    const row = copy.dimensions[d];
                    return (_jsxs("div", { style: {
                            borderTop: `1px solid ${theme.border}`,
                            paddingTop: 12,
                            display: 'grid',
                            gap: 6,
                            alignContent: 'start',
                        }, children: [_jsx("b", { style: { ...sans, color: theme.text, fontWeight: 500 }, children: row?.label ?? labelFromSlug(d) }), _jsx("p", { style: { ...sans, fontSize: 14, color: theme.body, margin: 0 }, children: row?.tooltip ?? '' })] }, d));
                }) })] }));
}
//# sourceMappingURL=LimitsBlock.js.map